<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">권한구성</span>
            <span class="txt">직원들의 권한을 어떻게 분류할지 설정합니다.</span>
        </div>

        <div class="com-table-wrap">
            <table class="com-table gray-header w400">
                <colgroup>
                    <col style="width: 100%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>직급명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ role.roleName }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <p class="sub-title">메뉴별 세부권한 수정하기</p>

        <div class="com-tab">
            <a
                v-for="(item, index) in menu"
                :key="index"
                :class="{ on: item.t_id == current }"
                class="menu"
                @click="current = item.t_id"
            >
                {{ item.t_menu_nm }}
            </a>
        </div>

        <div class="com-table-wrap">
            <table class="com-table no-border">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 400px" />
                    <col style="width: 854px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check th">
                                <input id="check-all" v-model="checkAll" name="check-all" type="checkbox" />
                                <label for="check-all">사용여부</label>
                            </div>
                        </th>
                        <th>번호</th>
                        <th>권한명</th>
                        <th>설명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in events" :key="index">
                        <td>
                            <div class="com-design-check">
                                <input
                                    :id="`event-${index}`"
                                    v-model="item.useYn"
                                    :name="item.menuEventCd"
                                    type="checkbox"
                                    @change="save(item.menuId, item.menuEventCd, $event.target.checked)"
                                />
                                <label :for="`event-${index}`"></label>
                            </div>
                        </td>
                        <td>{{ index + 1 }}</td>
                        <td class="left">{{ item.menuEventName }}</td>
                        <td class="left">{{ item.menuEventDesc }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

import { EventBus } from '../../../main';

export default {
    name: 'SettingAuthorDetail',
    mixins: [MixinAllowedMenu],
    components: { LoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        checkAll: {
            get() {
                for (let e of this.events) {
                    if (e.useYn === false) {
                        return false;
                    }
                }
                return true;
            },
            set(checked) {
                for (let e of this.events) {
                    e.useYn = checked;
                }
                this.saveAll();
            },
        },
    },
    data() {
        return {
            roleId: this.$route.params.roleId,
            isSaving: false,
            role: {},
            menu: [],
            data: [],
            events: [],
            current: '',
        };
    },
    beforeMount() {
        // 스웨거검색: 센터 직급권한 목록조회
        api.get(`/admin/api/centerStaffRole/${this.centerId}/all`).then((res) => {
            this.role = res.data.find((o) => o.roleId == this.$route.params.roleId);
        });

        api.get('/admin/api/centerStaffRole/menu/depth/1').then((res) => {
            this.current = res.data[0].t_id;
            this.menu = res.data;
        });

        api.get(`/admin/api/centerStaffRole/centerMenu/${this.centerId}/${this.$route.params.roleId}`).then((res) => {
            this.data = res.data;
        });
    },
    watch: {
        current(menuId) {
            this.select(menuId);
        },
        role(newVal) {
            console.log('Role data changed:', newVal);
        },
        menu(newVal) {
            console.log('Menu data changed:', newVal);
        },
        data(newVal) {
            console.log('Data changed:', newVal);
        },
    },
    mounted() {},
    methods: {
        select(menuId) {
            const { centerId, roleId } = this;
            api.get(`/admin/api/centerStaffRole/role/menu/event/all`, {
                params: {
                    centerId,
                    roleId,
                    menuId,
                },
            }).then((res) => {
                this.events = res.data;
            });
        },
        async save(menuId, menuEventCd, useYn) {
            const params = [
                {
                    roleId: this.role.roleId,
                    menuId,
                    menuEventCd,
                    useYn,
                },
            ];
            // if (menuId == 9 && menuEventCd == 'ME_EVENT_005') {
            //     if (useYn) {
            //         params.push({
            //             roleId: this.role.roleId,
            //             menuId: 9,
            //             menuEventCd: 'ME_EVENT_006',
            //             useYn: true,
            //         });
            //         params.push({
            //             roleId: this.role.roleId,
            //             menuId: 9,
            //             menuEventCd: 'ME_EVENT_007',
            //             useYn: true,
            //         });
            //
            //         this.events.map((item) => {
            //             if (item.menuEventCd == 'ME_EVENT_006' || item.menuEventCd == 'ME_EVENT_007') {
            //                 item.useYn = true;
            //             }
            //         });
            //     }
            //
            //     if (this.role.roleId == this.$store.state.auth.user.roleId) {
            //         EventBus.$emit('refresh_menu', { param: 1 });
            //     }
            // }

            await this.putCenterStaffRoleUpdateEvent(params);

            this.allowedMenuEvent.eventCds = null;
            this.initMixin();
        },
        async saveAll() {
            let params = [];
            for (let e of this.events) {
                params.push({
                    roleId: this.role.roleId,
                    menuId: e.menuId,
                    menuEventCd: e.menuEventCd,
                    useYn: e.useYn,
                });
            }

            await this.putCenterStaffRoleUpdateEvent(params);
        },
        async putCenterStaffRoleUpdateEvent(params) {
            await api.put(`/admin/api/centerStaffRole/update/roleEvent/${this.centerId}`, params).catch((errors) => {
                alert(`오류가 발생했습니다.\n${errors.response.data.message}`);
                console.error(errors);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.com-tab {
    .menu {
        min-width: 80px !important;
        cursor: pointer;
    }
}
</style>
